/* eslint-disable react/prop-types */
import React from 'react';
import { connect } from 'react-redux';
import { Formik } from 'formik';
import {
  FormGroup,
  Label,
  Input,
  Row,
  Col,
  Button,
} from 'reactstrap';
import { injectIntl } from 'react-intl';
import styled from 'styled-components';
import toastr from 'toastr';

import Loading from '../components/Loading';
import Content from '../components/layout/Content';
import FormError from '../components/formControls/FormError';
import SnipperButton from '../components/buttons/SpinnerButton';
import { getPortion, updatePortion } from '../api/portion';

class Portion extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      portion: '',
    };
  }

  async componentDidMount() {
    const { match: { params: { portionId } } } = this.props;
    const res = await getPortion(portionId);
    console.log('res', res);
    this.setState({ portion: res.data.portion });
  }

  render() {
    const { intl } = this.props;
    const {
      loading, portion,
    } = this.state;

    const portionDetailText = intl.formatMessage({ id: 'portion.detail' });
    const portionNameText = intl.formatMessage({ id: 'portion.name' });
    const portionPriceText = intl.formatMessage({ id: 'portion.price' });
    const savedText = intl.formatMessage({ id: 'saved' });
    const saveText = intl.formatMessage({ id: 'save' });

    return (
      <Row>
        <Col>
          <Formik
            initialValues={
              {
                displayName: portion && portion.displayName,
                price: portion && portion.price,
              }
            }
            enableReinitialize
            onSubmit={async (submit) => {
              await updatePortion({ id: portion.id, displayName: submit.displayName, price: submit.price });
              toastr.success('', savedText);
            }}
          >
            {({
              values,
              errors,
              handleChange,
              handleBlur,
              handleSubmit,
              /* and other goodies */
            }) => (
              <Content title={portionDetailText}>
                  {
                    !portion ? <Loading />
                      : (
                        <form onSubmit={handleSubmit} encType="multipart/form-data">
                          <FormGroup>
                            <Label for="displayName">{portionNameText}</Label>
                            <Input
                              type="text"
                              name="displayName"
                              id="displayName"
                              placeholder={portionNameText}
                              onChange={handleChange}
                              onBlur={handleBlur}
                              value={values.displayName}
                            />
                            {errors.name && <FormError error={errors.name} />}
                          </FormGroup>
                          <FormGroup>
                            <Label for="price">{portionPriceText}</Label>
                            <Input
                              type="number"
                              name="price"
                              id="price"
                              placeholder={portionPriceText}
                              onChange={handleChange}
                              onBlur={handleBlur}
                              value={values.price}
                            />
                            {errors.name && <FormError error={errors.name} />}
                          </FormGroup>
                          <SnipperButton type="submit" loading={loading} text={saveText} />
                        </form>
                      )
                  }
                </Content>
            )}
          </Formik>
        </Col>
      </Row>
    );
  }
}

const mapStateToProps = (state) => ({ user: state.auth.user });

export default injectIntl(connect(mapStateToProps)(Portion));
